import { gql } from '@apollo/client';

export const GET_PDF_PREVIEWS = gql`
  query GetPDFPreviews($input: GetPdfPreviewsInput!) {
    getPDFPreviews(input: $input) {
      height
      width
      urls {
        quality
        url
      }
    }
  }
`;
